import { render, staticRenderFns } from "./CsAvatar.vue?vue&type=template&id=0191db1b&scoped=true&"
import script from "./CsAvatar.vue?vue&type=script&setup=true&lang=js&"
export * from "./CsAvatar.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CsAvatar.vue?vue&type=style&index=0&id=0191db1b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0191db1b",
  null
  
)

export default component.exports